<template>
  <div class="live2d" ref="container">
    <div :id="mainLive2d.container" class="__live2d-container__" @click="handleStartAnimate"></div>
    <!-- <div class="mask" @click="executeAnimation(1)"> -->
    <div class="empty" v-if="isEmpty && !mainLive2d.loading">
      <img src="@/assets/zs_imgs/empty-img.png" alt="" />
      <div>资料暂时空缺，留言让版主加急</div>
    </div>
    <div class="loading" v-if="mainLive2d.loading">
      <div class="loader">
        <span class="item"></span>
        <span class="item"></span>
        <span class="item"></span>
        <span class="item"></span>
      </div>
      <div class="text">正在加载中哦</div>
    </div>
  </div>
</template>

<script>
import { loadScript, loadCSS } from "@/plugins/util";
import eventBus from "@/plugins/eventBus";

const initPostion = {
  large: { x: 0, y: 0, width: 0, height: 0 },
  small: { x: 0, y: 0, width: 0, height: 0 }
};

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String,
      default: ""
    },
    animation: {
      type: String,
      default: "idle"
    },
    live2dId: {
      type: String,
      required: false,
      default: "__spine_player_container__"
    },
    operationType: {
      type: Number,
      default: 0 // 0 放大， 1缩小
    }
  },
  data() {
    return {
      lhVisible: false,
      live2dVisible: false,
      petalEffect: null,
      isEmpty: false,
      hasViewNikkeLive2dGuide1: false,
      player: null,
      mainLive2d: {
        container: this.live2dId,
        loading: false,
        spinePlayer: null
      },
      isEditMode: false, // 是否是编辑模式
      // 默认放大live2d视口
      bigViewport: {
        stand: {
          x: -450,
          y: 50,
          width: 1600,
          height: 2000
        },
        combat: {
          x: this.type === "cover" ? -450 : -50,
          y: this.type === "cover" ? -800 : -800,
          width: 1600,
          height: 2000
        }
      },
      originalViewport: {
        stand: {
          x: -800,
          y: -300,
          width: 1600,
          height: 2400
        },
        combat: {
          x: this.type === "cover" ? -550 : -150,
          y: -1250,
          width: 1600,
          height: 2400
        }
      }
    };
  },
  watch: {
    dataSource: {
      immediate: true,
      handler() {
        if (this.$isServer) return;
        this.initSpineViewport();
        this.$nextTick(() => {
          this.init();
        });
      }
    },
    type(val) {
      this.bigViewport.combat.x = val === "cover" ? -450 : -50;
      this.bigViewport.combat.y = val === "cover" ? -800 : -800;
      this.originalViewport.combat.x = val === "cover" ? -450 : -50;
      this.initSpineViewport();
    },
    operationType: {
      deep: true,
      handler() {
        this.initSpineViewport();
        this.$nextTick(() => {
          this.init();
        });
      }
    },
    live2dId: {
      deep: true,
      handler(val) {
        if (val) {
          this.mainLive2d = {
            container: val,
            loading: false,
            spinePlayer: null
          };
        }
      }
    }
  },
  mounted() {
    eventBus.$off("updateView");
    eventBus.$on("updateView", (type, count) => {
      this.changePosition(type, count);
    });
    this.executeAnimation(1);
  },
  deactivated() {
    this.destroyDispose();
    this.unListening();
  },
  beforeDestroy() {
    this.unListening();
  },
  methods: {
    unListening() {
      // 移除事件监听
      eventBus.$off("updateView");
    },
    init() {
      this.destroyDispose();
      this.initSpine(this.mainLive2d);
    },
    destroyDispose() {
      if (this.player) {
        // 释放资源，销毁容器
        this.player.dispose();
        this.player = null;
      }
    },
    changePosition(emitType, count) {
      const positionKey = this.type === "full" ? "stand" : "combat";
      const NUMBER = 50 * count;

      const createViewportActions = viewport => ({
        up: () => (viewport[positionKey].y += NUMBER),
        down: () => (viewport[positionKey].y -= NUMBER),
        left: () => (viewport[positionKey].x -= NUMBER),
        right: () => (viewport[positionKey].x += NUMBER),
        shrink: () => {
          viewport[positionKey].width += NUMBER;
          viewport[positionKey].height += NUMBER;
        },
        amplify: () => {
          viewport[positionKey].width -= NUMBER;
          viewport[positionKey].height -= NUMBER;
        }
      });

      const bigActions = createViewportActions(this.bigViewport);
      const originalActions = createViewportActions(this.originalViewport);
      const actions = this.operationType === 0 ? bigActions : originalActions;
      const currentViewport = this.operationType === 0 ? this.bigViewport : this.originalViewport;

      if (actions[emitType]) {
        actions[emitType]();
        eventBus.$emit("updateViewData", currentViewport[positionKey]);

        if (this.operationType === 0) {
          this.$set(this.bigViewport, positionKey, { ...this.bigViewport[positionKey] });
        } else {
          this.$set(this.originalViewport, positionKey, { ...this.originalViewport[positionKey] });
        }
        this.isEditMode = true;

        // this.initSpineViewport();
        this.init();
      } else {
        this.isEditMode = false;

        this.$emit("onPublish", {
          position: currentViewport[positionKey],
          type: this.operationType === 0 ? "large" : "small",
          live2dType: this.type
        });
      }
    },
    initSpineViewport() {
      const val = this.dataSource;
      const position = val.source.value.position;
      const object = position && position.pc ? { ...initPostion, ...position.pc } : initPostion;
      const viewportKey = this.type === "full" ? "stand" : "combat";
      for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
          let element = object[key];
          if (!element) return;
          if (typeof element !== "object") {
            element = JSON.parse(element);
          }
          if (key === "large") {
            if (element.x || element.y) {
              this.bigViewport[viewportKey].x = element.x;
              this.bigViewport[viewportKey].y = element.y;
              this.bigViewport[viewportKey].width = element.width;
              this.bigViewport[viewportKey].height = element.height;
            }
          }
          if (key === "small") {
            if (element.x || element.y) {
              this.originalViewport[viewportKey].x = element.x;
              this.originalViewport[viewportKey].y = element.y;
              this.originalViewport[viewportKey].width = element.width;
              this.originalViewport[viewportKey].height = element.height;
            }
          }
        }
      }
    },
    initSpine(live2d) {
      const vm = this;
      live2d.loading = true;
      const data = this.dataSource.source.value;
      const container = document.getElementById(live2d.container);

      if (typeof data === "object") {
        if (!data.skel) {
          this.loading = false;
          return;
        }
        this.isEmpty = false;

        const vp = this.operationType === 0 ? this.bigViewport : this.originalViewport;
        // 放大视口
        const viewport = {
          stand: {
            x: vp.stand.x,
            y: vp.stand.y,
            width: vp.stand.width,
            height: vp.stand.height,
            padLeft: "10%",
            padRight: "10%",
            padTop: "10%",
            padBottom: "10%"
          },
          combat: {
            x: vp.combat.x,
            y: vp.combat.y,
            width: vp.combat.width,
            height: vp.combat.height,
            padLeft: "10%",
            padRight: "10%",
            padTop: "10%",
            padBottom: "10%"
          }
        };
        const startTime = Date.now();
        // 埋点开始加载live2d
        if (window.staticFn) {
          window.staticFn.customEvent("pc_live2d_load_start");
        }
        const options = {
          // Relative URLs
          skelUrl: this.foramtUrl(data.skel),
          atlasUrl: this.foramtUrl(data.atlas),
          animation: this.animation,
          showLoading: false,
          showControls: false,
          alpha: true,
          premultipliedAlpha: true,
          backgroundColor: "#00000000",
          viewport: viewport[this.type === "full" ? "stand" : "combat"],
          success: function(player) {
            live2d.loading = false;
            live2d.spinePlayer = player;
            vm.player = player;
            vm.initViewLive2dScale();
            // 埋点上报live2d加载成功
            if (window.staticFn) {
              window.staticFn.customEvent("pc_live2d_load_success", {
                value: Date.now() - startTime
              });
            }
          },
          error: (player, reason) => {
            // 埋点上报live2d加载失败
            if (window.staticFn) {
              window.staticFn.customEvent("pc_live2d_load_fail", {
                value: Date.now() - startTime,
                reason: reason
              });
            }
          }
        };
        fetch(data.skel)
          .then(response => response.blob())
          .then(blob => blob.slice(0, 16).text())
          .then(str => {
            if (/4\.0\.\d+/.test(str)) {
              // 加载css
              loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.0.30.css?t=10001`);
              loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.0.30.js?t=10001`).then(res => {
                // 先获取到spine可执行的动画
                container.innerHTML = null;
                // eslint-disable-next-line
                new window.spine_4_0_30.SpinePlayer(container, options);
              });
            } else if (/4\.1\.\d+/.test(str)) {
              // 加载css
              loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.css?t=10001`);
              loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.js?t=10001`).then(res => {
                // 先获取到spine可执行的动画
                container.innerHTML = null;
                // eslint-disable-next-line
                new window.spine_4_1_54.SpinePlayer(container, options);
              });
            }
          })
          .catch(error => {
            this.isEmpty = true;
            // 埋点上报live2d加载失败
            if (window.staticFn) {
              window.staticFn.customEvent("pc_live2d_load_fail", {
                value: Date.now() - startTime,
                reason: error.message
              });
            }
          });
      } else if (data) {
        live2d.loading = false;
        this.isEmpty = false;
        container.innerHTML = `<img class="lh-img" src="${data}" alt="" />`;
      } else {
        live2d.loading = false;
        this.isEmpty = true;
      }
    },
    initViewLive2dScale() {
      const spineContainer = document.querySelector("div.el-dialog__wrapper div.__live2d-container__");
      if (!spineContainer) return;
      const canvas = spineContainer.querySelector(".spine-player-canvas");
      canvas.style.height = "4500px";
      canvas.style.width = spineContainer.clientWidth + "px";
      canvas.style.transform = "translateX(0) translateY(-1800px) scale(0.7)";
      spineContainer.style.overflow = "hidden";
      const container = spineContainer.querySelector("canvas");
      let scale = 0.7;
      const zoomFactor = 0.05;
      let isDragging = false;
      let startX, startY;
      let offsetX = 0;
      let offsetY = -1800;

      // 滚轮缩放
      container.addEventListener("wheel", function(event) {
        event.preventDefault();

        // 计算鼠标相对于容器的位置（用于缩放中心点）
        // const rect = container.getBoundingClientRect();
        // const mouseX = event.clientX - rect.left;
        // const mouseY = event.clientY - rect.top;

        // 保存缩放前的鼠标在变换空间中的位置
        // const oldX = (mouseX - offsetX) / scale;
        // const oldY = (mouseY - offsetY) / scale;

        // 调整缩放比例
        const delta = event.deltaY > 0 ? -1 : 1;
        scale *= 1 + delta * zoomFactor;
        scale = Math.min(Math.max(0.5, scale), 3);

        // 计算新的偏移量，使鼠标位置保持不变
        // offsetX = mouseX - oldX * scale;
        // offsetY = mouseY - oldY * scale;

        // console.log(mouseX, mouseY, oldX, oldY, offsetX, offsetY);

        updateTransform();
      });

      // 拖动平移
      container.addEventListener("mousedown", function(event) {
        isDragging = true;
        startX = event.clientX - offsetX;
        startY = event.clientY - offsetY;
      });

      document.addEventListener("mousemove", function(event) {
        if (!isDragging) return;

        offsetX = event.clientX - startX;
        offsetY = event.clientY - startY;

        updateTransform();
      });

      document.addEventListener("mouseup", function() {
        isDragging = false;
      });

      function updateTransform() {
        container.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
      }
    },
    executeAnimation(type) {
      if (type === 1) {
        const { spinePlayer } = this.mainLive2d;
        this.changeAnimation(spinePlayer);
      }
      this.animateTimer = setTimeout(this.executeAnimation, 5000, type);
    },
    changeAnimation(spinePlayer) {
      if (spinePlayer) {
        const animations = spinePlayer.animationState.data.skeletonData.animations;
        const actionTypeObj = {
          aim: "aim_fire",
          cover: "to_aim",
          full: "action"
        };
        const actionName = actionTypeObj[this.type] || "";

        // 获取到motion动画
        const motionAnimation = animations.find(item => {
          return item.name === actionName;
        });
        if (motionAnimation) {
          spinePlayer.setAnimation(actionName, false);
          setTimeout(() => {
            spinePlayer.setAnimation(this.animation, true);
          }, motionAnimation.duration * 1000);
        }
      }
    },
    foramtUrl(url) {
      if (url.startsWith("//")) {
        return `${location.protocol}${url}`;
      } else {
        return url;
      }
    },
    coverGuide(cover, target) {
      // const body = document.body;
      const doc = document.documentElement;

      function clearRoundRect(context, x, y, width, height, radius) {
        context.save();
        context.beginPath();
        context.roundRect(x, y, width, height, radius);
        context.clip();
        context.clearRect(x, y, width, height);
        context.restore();
      }

      function clearArc(context, x, y, radius) {
        context.save();
        context.beginPath();
        context.arc(x, y, radius, 0, 2 * Math.PI, false);
        context.clip();
        context.clearRect(x - radius - 1, y - radius - 1, radius * 2 + 2, radius * 2 + 2);
        context.restore();
      }

      if (cover && target) {
        // target size(width/height)
        const targetWidth = target.clientWidth;
        const targetHeight = target.clientHeight;

        // page size
        const pageWidth = doc.clientWidth;
        const pageHeight = doc.clientHeight;

        // offset of target
        const offsetTop = target.getBoundingClientRect().top;
        const offsetLeft = target.getBoundingClientRect().left;

        // set size and border-width
        cover.style.width = pageWidth + "px";
        cover.style.height = pageHeight + "px";

        // 设置content位置
        const contentBox = this.$refs.guideContent;
        contentBox.style.top = offsetTop + "px";
        contentBox.style.left = offsetLeft + "px";
        contentBox.style.width = targetWidth + "px";
        contentBox.style.height = targetHeight + "px";

        const canvas = this.$refs.guideCanvas;
        const ctx = canvas.getContext("2d");
        canvas.width = pageWidth;
        canvas.height = pageHeight;
        // ctx.clearRect(0, 0, pageWidth, pageHeight);
        ctx.fillStyle = "rgba(0,0,0,0.75)";
        ctx.fillRect(0, 0, pageWidth, pageHeight);
        // 镂空区域
        clearRoundRect(ctx, offsetLeft, offsetTop, targetWidth, targetHeight, 24);
        ctx.beginPath();
        // 方型镂空区域增加背景
        ctx.fillStyle = "rgba(0,0,0,0.2)";
        ctx.roundRect(offsetLeft, offsetTop, targetWidth, targetHeight, 24);
        ctx.fill();
        ctx.closePath();
        // 镂空区域增加中心圆形镂空
        clearArc(ctx, offsetLeft + targetWidth / 2, offsetTop + targetHeight / 2 - 46, 53);

        cover.querySelector(".guide-content").style.paddingTop = offsetTop + targetHeight / 2 - 46 - 115 + "px";
        // resize
        if (!cover.isResizeBind) {
          window.addEventListener("resize", () => {
            this.coverGuide(cover, target);
          });
          cover.isResizeBind = true;
        }
      }
    },
    onViewGuide() {
      document.body.style.overflow = null;
      this.hasViewNikkeLive2dGuide1 = true;
      localStorage.setItem("hasViewNikkeLive2dGuide1", true);
    },
    handleStartAnimate() {
      // 清除自动定时执行动画
      if (this.animateTimer) {
        clearTimeout(this.animateTimer);
      }
      // 清除手动执行动画后，5s后开始自动循环动画执行
      if (this.startNowTimer) {
        clearTimeout(this.startNowTimer);
      }
      const { spinePlayer } = this.mainLive2d;
      this.changeAnimation(spinePlayer);
      this.startNowTimer = setTimeout(this.executeAnimation, 5000, 1);
    }
  }
};
</script>

<style lang="less" scoped>
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #e4e4e4;
  line-height: 14px;
  margin-top: -100px;

  img {
    width: 190px;
    height: 163px;
    margin-bottom: 7px;
  }
}

.loading {
  //position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 400;
  font-size: 12px;
  color: #333;
  line-height: 14px;

  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 20px;

    .item {
      display: inline-block;
      position: relative;
      box-sizing: border-box;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background: #3eafff;
      animation: ball-beat 0.7s -0.15s infinite linear;

      &:nth-child(2n-1) {
        animation-delay: -0.5s;
      }
    }

    @keyframes ball-beat {
      50% {
        opacity: 0.2;
        transform: scale(0.75);
      }

      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}

.live2d {
  position: relative;
  width: 100%;
  height: 100%;

  /deep/ .__live2d-container__ {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 380px;
      max-height: 100%;
    }
  }

  // .bg {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 638px;
  //   background: url("~@/assets/zs_imgs/live2d-box-bg.png");
  //   background-size: 100% 100%;
  // }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: #ffffff00;
    color: #ffffff00;
    display: flex;
    align-items: center;
    justify-content: center;

    .btns {
      position: absolute;
      right: 0;
      top: 21px;
      width: 68px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 14px;
    }

    .btn {
      display: inline-block;
      width: 27px;
      height: 27px;
      background: rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      img {
        width: 18px;
        height: 18px;
      }
    }
  }
}

.cursor-guide-box {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .live2d_animation {
    position: relative;
    width: 230px;
    height: 230px;
    overflow: hidden;

    .cursor-icon {
      position: absolute;
      width: 230px;
      height: 230px;
      top: 0;
      left: 0;
      background: url("~@/assets/zs_imgs/live2d_guide.png") no-repeat;
      background-size: 22540px 230px;
      animation: spriteAnimation 3s steps(98) infinite;
    }

    @keyframes spriteAnimation {
      from {
        background-position: 0 0;
      }
      to {
        background-position: -22540px 0;
      }
    }
  }
}

.guide-box {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;

  canvas {
    width: 100%;
    height: 100%;
  }

  .guide-content {
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: column;

    .click-icon {
      width: 55px;
      height: 70px;
      margin-bottom: 25px;
    }

    .line-icon {
      width: 3px;
      height: 181px;
      margin-bottom: 11px;
    }

    .dot {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #757474;
      border-radius: 50%;
      margin-bottom: 16px;

      &::after {
        content: "";
        display: block;
        width: 8px;
        height: 8px;
        background: #fff;
        border-radius: 50%;
      }
    }

    .tips {
      font-weight: bold;
      font-size: 22px;
      color: #ffffff;
      line-height: 23px;
      margin-bottom: 29px;
    }

    .btn {
      width: 134px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(123, 213, 255, 0.5);
      border-radius: 20px;
      font-weight: 400;
      font-size: 16px;
      color: #82fff8;
      cursor: pointer;
    }
  }
}
</style>
